//@flow
import * as Immutable from 'immutable';

import {
    StatusUpdate,
    TaskStatusUpdate
} from 'common/models/flow/StatusUpdate';
import type {
    StatusUpdateModelType,
    TaskStatusUpdateModelType
} from 'common/models/flow/StatusUpdate';

import { VehicleStatus } from './VehicleStatus';
import { LatLng } from './LatLng';
import { TaskChecklistValue } from './TaskPod';

class InternalStatusUpdate extends StatusUpdate {
    static fromJS(json: StatusUpdateModelType): InternalStatusUpdate {
        const state: Object = Object.assign({}, json);
        state.latlng = state.latlng
            ? LatLng.fromJS(state.latlng)
            : state.latlng;
        state.vehicleStatus = state.vehicleStatus
            ? VehicleStatus.fromJS(state.vehicleStatus)
            : state.vehicleStatus;
        state.checklistValues = Immutable.List(
            state.checklistValues
        ).map(item => TaskChecklistValue.fromJS(item));
        return new this(Immutable.Map(state));
    }

    get latlng(): ?LatLng {
        return this._state.get('latlng');
    }

    get vehicleStatus(): ?VehicleStatus {
        return this._state.get('vehicleStatus');
    }

    get checklistValues(): Immutable.List<TaskChecklistValue> {
        return this._state.get('checklistValues');
    }
}

class InternalTaskStatusUpdate extends TaskStatusUpdate {
    static fromJS(json: TaskStatusUpdateModelType): InternalTaskStatusUpdate {
        const state: Object = Object.assign({}, json);
        state.accepted = state.accepted
            ? InternalStatusUpdate.fromJS(state.accepted)
            : state.accepted;
        state.assigned = state.assigned
            ? InternalStatusUpdate.fromJS(state.assigned)
            : state.assigned;
        state.cancelled = state.cancelled
            ? InternalStatusUpdate.fromJS(state.cancelled)
            : state.cancelled;
        state.completed = state.completed
            ? InternalStatusUpdate.fromJS(state.completed)
            : state.completed;
        state.started = state.started
            ? InternalStatusUpdate.fromJS(state.started)
            : state.started;
        state.arrived = state.arrived
            ? InternalStatusUpdate.fromJS(state.arrived)
            : state.arrived;
        return new this(Immutable.Map(state));
    }

    get accepted(): ?InternalStatusUpdate {
        return this._state.get('accepted');
    }

    get assigned(): ?InternalStatusUpdate {
        return this._state.get('assigned');
    }

    get cancelled(): ?InternalStatusUpdate {
        return this._state.get('cancelled');
    }

    get completed(): ?InternalStatusUpdate {
        return this._state.get('completed');
    }

    get started(): ?InternalStatusUpdate {
        return this._state.get('started');
    }

    get arrived(): ?InternalStatusUpdate {
        return this._state.get('arrived');
    }
}

export {
    InternalStatusUpdate as StatusUpdate,
    InternalTaskStatusUpdate as TaskStatusUpdate
};
